import React, { Fragment, useState, useContext  } from 'react';
import { SideBarContext } from '_context/LayoutContext';
import { Pagination } from 'component/Pagination';

 export const Footer = ({pageCount, setPageIndex, mode}) => {

    const { toggle, sidebar } = useContext(SideBarContext);
    return (
        <Fragment>
        {
            pageCount > 0 && 
            <div className="wrapBot">
            <Pagination pageCount={pageCount} onChange={setPageIndex} />
            <a href="https://apilink.kt.co.kr/Geomaster" target="_blank" className="btnLink">GIS 신규계약안내</a>
            </div>
        }
        <div className="btnToggleWrap">
        <button className="btnsSch btnToggle" onClick={() => toggle("sidebar")}>열기/닫기</button>
        </div>
        </Fragment>
    );
  };